<div class="init-match-container">
    <h2>Establecer jugador</h2>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="fill">
            <mat-label>Jugador</mat-label>
            <input matInput formControlName="player" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit" [disabled]="form.invalid">Guardar</button>
            <button matButton="outlined" type="button" (click)="exit()">Salir</button>
        </div>
    </form>
</div>